<template>
  <SurveyForm @on-submit="addSurvey"> </SurveyForm>
</template>
<script>
import SurveyForm from "./SurveyForm.vue";
import { service_names } from "@/constants/Services";
import { Message } from "@/helpers/utils";
import { survey_router_names } from "@/routes/routes";

export default {
  components: {
    SurveyForm
  },
  data() {
    return {};
  },
  methods: {
    addSurvey(dataSurvey) {
      this.$axios
        .post(`${service_names.school}/survey`, dataSurvey)
        .then(() => {
          Message.success(this.$t("common.add_success"));
          this.$router.push({ name: survey_router_names.listPage });
        });
    }
  }
};
</script>
